import React, {useContext} from 'react';
import {Switch, Route, useHistory} from 'react-router-dom';
import {Footer} from './components';
import {AdminSideNavToolbar as SideNavBarLayout} from './layouts';
import appInfo from './app-info';
import shipmentsRoute from './components/top-navigation/admin/routes';
import {NavbarContext} from './contexts/top-navigation';
import Session from './sessions';

export default function () {
    const menu = useContext(NavbarContext);
    const history = useHistory();
    const userId =  Session.getSession("user")?.id;
    const auth = Session.getSession("user")?.access_token;
    var href = window.location.href.split("/");
    var exthref = window.location.href.split("?");

    const Routes = () => {
        return(
            shipmentsRoute.map(({path, component}) => (<Route exact key={path} path={path} component={component}/>))
        );
    
    }   

    return (
        <React.Fragment>
            <SideNavBarLayout title={appInfo.title}>
                <Switch>
                    <Routes />
                </Switch>
                <Footer>
                    Copyright © 2020 {appInfo.company}
                    <br/>
                    All trademarks or registered trademarks are property of their respective owners.
                </Footer>
            </SideNavBarLayout>
        </React.Fragment>
    );
}
